import { render, staticRenderFns } from "./UserPromotion.vue?vue&type=template&id=1370157d&scoped=true&"
import script from "./UserPromotion.vue?vue&type=script&lang=js&"
export * from "./UserPromotion.vue?vue&type=script&lang=js&"
import style0 from "./UserPromotion.vue?vue&type=style&index=0&id=1370157d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370157d",
  null
  
)

export default component.exports